import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { IconTooltip } from '..';
import { Error } from '@wix/wix-ui-icons-common/on-stage';
import { TooltipSkin } from '../Tooltip/types';

visualize('IconTooltip', () => {
  story('simple', () => {
    snap(
      'default props',
      <IconTooltip
        message="The data you’ve entered is invalid"
        icon={<Error />}
      />,
    );
    snap(
      'showTooltip: true',
      <IconTooltip
        message="The data you’ve entered is invalid"
        icon={<Error />}
        showTooltip
      />,
    );
    snap(
      'showTooltip: true, skin: "error"',
      <IconTooltip
        message="The data you’ve entered is invalid"
        icon={<Error />}
        tooltipSkin={TooltipSkin.Error}
        showTooltip
      />,
    );
  });
});
